<wiz-vgroup width="100%" height="100%" gap="2" horizontalAlign="end" class="section-container">
  <wiz-hgroup width="100%" height="45px">
    <wiz-label #lbTitle width="100%" class="componentLabel"></wiz-label>
    <wiz-icon class="image-purple" width="30px" height="30px" (click)="doCancel()">close</wiz-icon>
  </wiz-hgroup>

  <tool-pivot-component
    #vspKeyMatrix
    width="100%"
    height="100%"
    toolMode="LIST"
    [model]="model"
    [uid]="'vspPivot'"
    [showHeader]="false"
    [pivotMode]="true"
    [templatingMode]="true"
    [selectionMode]="selectionMode"
  ></tool-pivot-component>

  <wiz-hgroup width="100%" verticalAlign="end" horizontalAlign="space-between" gap="2">
    <filter-component #popFilter width="130px"> </filter-component>
    <wiz-button
      #btnSave
      [wizLabel]="'$.pivot.filterkey.edit.$'"
      [wizIcon]="'icon-arrow-right'"
      (click)="save()"
      [iconPlacement]="'right'"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
